import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import BookingHome from '../pages/BookingHome';
import NotFound from './NotFound';
import {
  BOOK_ADHD,
  BOOK_ADHD_QUESTIONNAIRE,
  CLIENT_DETAILS,
  DOCTORS_ROUTE,
  REVIEW,
  MEDICARE_AND_HEALTH,
  ROOT_ROUTE,
  SPECIALITIES_ROUTE,
  THANKS,
} from '../constants/routes';
import ClientDetails from '../pages/ClientDetails';
import MedicareAndHealth from '../pages/MedicareAndHealth';
import Review from '../pages/Review';
import Thanks from '../pages/Thanks';
import Appointment from '../pages/Appointment';
import AdhdPortal from '../pages/AdhdPortal';
import AdhdQuestionnairePortal from '../pages/AdhdQuestionnairePortal';

const RouterConfig: FC = () => (
  <Routes>
    <Route path={BOOK_ADHD_QUESTIONNAIRE} element={<AdhdQuestionnairePortal />} />
    <Route path={BOOK_ADHD} element={<AdhdPortal />} />
    <Route path={ROOT_ROUTE} element={<BookingHome />}>
      <Route path={SPECIALITIES_ROUTE} element={<Appointment />} />
      <Route path={DOCTORS_ROUTE} element={<Appointment />} />
      <Route path={CLIENT_DETAILS} element={<ClientDetails />} />
      <Route path={MEDICARE_AND_HEALTH} element={<MedicareAndHealth />} />
      <Route path={REVIEW} element={<Review />} />
      <Route path={THANKS} element={<Thanks />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default RouterConfig;
